import React from "react";
import { Question } from "../types/question.types";
import Instruction from "./Instruction";
import Likert from "./Likert";
import MultipleChoice from "./MultipleChoice";

export interface QuestionRendererProps {
  question: Question;
  questionNumber?: number;
  answers?: Record<string, number>;
  onAnswerChange?: (answerKey: string, value: number) => void;
  onAnswersBatch?: (payload: Record<string, number>) => void;
}

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  questionNumber,
  answers,
  onAnswerChange,
  onAnswersBatch,
}) => {
  return (
    <div className="flex flex-col min-h-0">
      {questionNumber != null && question.layout !== "instructions" && (
        <h2
          className="text-[#b0b6cc] font-primary font-semibold text-lg mb-4 text-center"
          style={{ fontFamily: "var(--font-primary)" }}
        >
          Question {questionNumber}
        </h2>
      )}

      {question.layout === "instructions" && (
        <Instruction details={question.attributes.details} />
      )}

      {question.layout === "likert" && (
        <Likert
          question={question}
          value={
            answers?.[question.attributes.answer_key] ?? answers?.[question.key]
          }
          onChange={onAnswerChange}
        />
      )}

      {question.layout === "multiple_choice" && (
        <MultipleChoice
          question={question}
          value={answers}
          onChange={onAnswersBatch}
        />
      )}
    </div>
  );
};

export default QuestionRenderer;
